import { TAPIStatus } from '../../api/ba-app.api';
import { TPaginationInfo } from '../../input-app/fabric-inspection/api.types';
import { TUploadResponseDTO } from '@monorepo/services';
import { TFabricDefectCategories } from '../fabric-inspection/api.type';

export type TRESPONSE_FileUpload = {
  totalProcessedRows: number;
  successfulRows: number;
  failedRows: number;
  errors: number;
  errorFileKeyOpt: string;
  errorMessageOpt: string;
};

export type TREQUEST_OperationsUploadsListing = {
  factoryId: string;
  department: string;
  pageNo?: number;
  pageSize?: number;
  searchStringOpt: string | null;
};

export type TRESPONSE_OperationsUploadsFilesList = {
  factoryId: string;
  department: string;
  operationFiles: TOperationsUploadFileDTO[];
  searchStrOpt: string;
  paginationInfo: TPaginationInfo;
};

export type TOperationsUploadFileDTO = {
  fileName: string;
  fileKey: string;
  updatedTime: number;
  productType: string | null;
};

export type TRESPONSE_OperationsDropdownData = {
  factoryId: string;
  productTypes: string[];
  styles: string[];
};

export type TDepartmentStyleAndProductType = {
  style: string;
  productType: string;
  department: string;
};

export type TREQUEST_ProductTypesByStyle = {
  factoryId: string;
  style: string;
};

export type TRESPONSE_ProductTypesByStyle = TREQUEST_ProductTypesByStyle & {
  productTypes: string[];
};

export type TREQUEST_StylesByProductType = {
  factoryId: string;
  productType: string;
};

export type TRESPONSE_StylesByProductType = TREQUEST_StylesByProductType & {
  styles: string[];
};

export type TREQUEST_OperationsByStyleAndProduct = TREQUEST_ProductTypesByStyle & {
  department: string;
  productType: string;
};

export type TRESPONSE_OperationsByStyleAndProduct = TREQUEST_OperationsByStyleAndProduct & {
  overridesProductTypeOperations: boolean;
  operations: TOperationDTO[];
};

export type TOperationDTO = {
  name: string;
  id: string;
  uniqueId?: string;
  operator: string;
  machineType: string;
  criticality: string;
  smv: string;
};

export type TRequestPayload = {
  factoryId: string;
  department: string;
  style: string;
  productType: string;
};

export type TUpdateOperationsProductTypeActions = 'ASSIGN' | 'UNASSIGN' | 'DELETE';

export type TREQUEST_OperationUpdate = {
  factoryId: string;
  department: string;
  fileKey: string;
  productType: string;
  action: TUpdateOperationsProductTypeActions;
};

export type TOperationsErrorTypes = 'TOP_LEVEL_ERROR';

export type TOperationsError = {
  errorType: TOperationsErrorTypes;
  errors: string[];
};

export type TRESPONSE_GenericResponse = {
  status: TAPIStatus;
  errors: TOperationsError[];
};

export type TOperationsStyleOverrideActions = 'OVERRIDE' | 'UNDO_OVERRIDE';

type TSource = {
  source_type: 'ba-app';
  source_id: string;
};

export type TREQUEST_OperationsStyleOverride = TRequestPayload & {
  source: TSource;
  action: TOperationsStyleOverrideActions;
};

export type TREQUEST_StyleAndProductSpecificOperation = TRequestPayload & {
  source: TSource;
  operation: TOperationDTO;
};

export type TREQUEST_OperationStyleDelete = TRequestPayload & {
  operationIds: string[];
};

export type TREQUEST_IssuesListing = {
  factoryId: string;
  department: string;
  // pageNo?: number;
  // pageSize?: number;
};

export type TIssueListType = 'DEFECT_LIST' | 'REJECT_LIST';

export type TIssueCategory =
  | 'MAJOR'
  | 'MINOR'
  | 'CRITICAL'
  | 'OTHER'
  | 'FABRIC'
  | 'TRIMS'
  | 'CONSTRUCTION'
  | 'STITCHING_SEWING'
  | 'M_MEASUREMENT'
  | 'CLEANLINESS_TRIMING'
  | 'LAUNDRY_WASHING';
export const IssueCategories: TIssueCategory[] = ['MAJOR', 'MINOR', 'CRITICAL', 'OTHER'];
export const YnlIssueCategories: TIssueCategory[] = [
  'FABRIC',
  'TRIMS',
  'CONSTRUCTION',
  'STITCHING_SEWING',
  'M_MEASUREMENT',
  'CLEANLINESS_TRIMING',
  'LAUNDRY_WASHING',
  'OTHER',
];

export type TIssueType = 'GENERIC_ISSUE' | 'MAPPED_ISSUE';

export type TMappedIssueDTO = {
  issueName: string;
  issueId: string;
};

export type TMappedIssueDTOWithType = TMappedIssueDTO & {
  type: 'MAPPED_ISSUE';
};
type TGenericIssueMetadata = {
  issueName: string;
  issueId: string;
  category: TIssueCategory;
};
export type TGenericIssueDTO = TGenericIssueMetadata & {
  issueListTypes: Record<TIssueListType, boolean>;
};

export type TGenericIssueDTOWithType = TGenericIssueMetadata & {
  type: 'GENERIC_ISSUE';
};

export type TRESPONSE_IssuesListing = {
  factoryId: string;
  department: string;
  issues: TGenericIssueDTO[];
};

type TIssueUpdateActions = 'EDIT' | 'DELETE';

export type TREQUEST_GeneralIssueUpdate = {
  factoryId: string;
  department: string;
  issue: TGenericIssueDTO;
  action: TIssueUpdateActions;
};

export type TREQUEST_GeneralIssuesAddMultiple = {
  factoryId: string;
  department: string;
  issues: TGenericIssueDTO[];
  user: string;
};

export type TREQUEST_GeneralIssuesDeleteMultiple = {
  factoryId: string;
  department: string;
  issues: TGenericIssueDTO[];
};

type TOperationSpecificIssue = {
  operation: TOperationDTO;
  issues: TMappedIssueDTO[];
};

export type TRESPONSE_OperationSpecificIssues = TRequestPayload & {
  operationSpecificIssues: TOperationSpecificIssue[];
};

export type TREQUEST_OperationSpecificIssueDelete = TRequestPayload & {
  operationId: string;
};

export type TREQUEST_OperationSpecificIssuesUpdate = TRequestPayload & {
  operationId: string;
  issues: TMappedIssueDTO[];
  source: TSource;
};

export type TParams_UploadOperationSpecificIssuesFile = {
  style: string;
  productType: string;
  operationId: string;
};

export type TSampleTemplateKey =
  | 'GENERAL_PRODUCT_TYPE_OPERATIONS_TEMPLATE'
  | 'STYLE_SPECIFIC_OPERATIONS_TEMPLATE'
  | 'GENERAL_ISSUES_TEMPLATE'
  | 'OPERATION_SPECIFIC_ISSUES_TEMPLATE';

export enum SampleTemplateFilenames {
  GENERAL_PRODUCT_TYPE_OPERATIONS_TEMPLATE = 'general-product-type-operations-sample-template',
  STYLE_SPECIFIC_OPERATIONS_TEMPLATE = 'style-specific-operations-sample-template',
  GENERAL_ISSUES_TEMPLATE = 'general-issues-sample-template',
  OPERATION_SPECIFIC_ISSUES_TEMPLATE = 'operation-specific-issues-sample-template',
}

export type TUploadComponentInput =
  | {
      type: 'UPLOAD_GENERAL_OPERATIONS_FILE';
      department: TFactoryDepartment;
    }
  | {
      type: 'UPLOAD_STYLE_SPECIFIC_OPERATIONS_FILE';
      department: TFactoryDepartment;
      style: string;
      productType: string;
    }
  | {
      type: 'UPLOAD_GENERAL_ISSUES_FILE';
      department: TFactoryDepartment;
    }
  | {
      type: 'UPLOAD_OPERATION_SPECIFIC_ISSUES_FILE';
      department: TFactoryDepartment;
      style: string;
      productType: string;
      operationId: string;
    };

export type TUploadComponentName =
  | 'UPLOAD_GENERAL_OPERATIONS_FILE'
  | 'UPLOAD_STYLE_SPECIFIC_OPERATIONS_FILE'
  | 'UPLOAD_GENERAL_ISSUES_FILE'
  | 'UPLOAD_OPERATION_SPECIFIC_ISSUES_FILE';

type TUploadFile = {
  file: File;
  department: string;
};

export type TGeneralOperationsUploadPayload = TUploadFile & {
  uploadType: 'UPLOAD_GENERAL_OPERATIONS_FILE';
};

export type TStyleSpecificUploadPayload = TUploadFile & {
  uploadType: 'UPLOAD_STYLE_SPECIFIC_OPERATIONS_FILE';
  style: string;
  productType: string;
};

export type TGeneralIssuesUploadPayload = TUploadFile & {
  uploadType: 'UPLOAD_GENERAL_ISSUES_FILE';
};

export type TOperationSpecificIssuesUploadPayload = TUploadFile & {
  uploadType: 'UPLOAD_OPERATION_SPECIFIC_ISSUES_FILE';
  style: string;
  productType: string;
  operationId: string;
};

export type TUploadPayload =
  | TGeneralOperationsUploadPayload
  | TStyleSpecificUploadPayload
  | TGeneralIssuesUploadPayload
  | TOperationSpecificIssuesUploadPayload;

export type TUploadAndRefetch = {
  summary: TUploadResponseDTO;
  uploadType: TUploadComponentName;
  department: string;
  style?: string;
  productType?: string;
  operationId?: string;
};

export type TREQUEST_DepartmentList = {
  factoryId: string;
  feature: TFeatureOptions;
};

export type TFeatureOptions = 'OPERATION_ISSUE_MAPPING' | 'MANPOWER' | 'CAPACITY';

export type TDomRole = {
  id: string;
  displayName: string;
};

export type TFactoryDepartment = {
  id: string;
  displayName: string;
  domRoles: TDomRole[] | null;
};

export type TRESPONSE_DepartmentList = {
  factoryId: string;
  departments: TFactoryDepartment[];
  feature: TFeatureOptions;
};

export type TAddStyleOperationInputs = {
  style: string;
  productType: string;
  department: TFactoryDepartment;
};

export type TEditOperationSpecificIssueInputs = {
  row: TOperationSpecificIssue;
  style: string;
  productType: string;
  department: TFactoryDepartment;
};

export type TAddNewIssueRow = {
  issueId: string;
  issueName: string;
  category: TIssueCategory;
  defect_list: boolean;
  reject_list: boolean;
};

export type TCategoryType = {
  key: TIssueCategory | TFabricDefectCategories;
  displayName: string;
};
